import script from "./DataBox.vue?vue&type=script&setup=true&lang=js"
export * from "./DataBox.vue?vue&type=script&setup=true&lang=js"

import "./DataBox.vue?vue&type=style&index=0&id=da8c8a08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da8c8a08"]])

export default __exports__